export class OperationSchedulerTask {

  constructor(
    public operationHash?: string,
    public operationName?: string,
    public operationCode?: string,
    public schedulerTaskHash?: string,
    public manufacturingOrderCode?: string,
    public isSent?: boolean
  ) { }

  clone() {
    return new OperationSchedulerTask (
      this.operationHash,
      this.operationName,
      this.operationCode,
      this.schedulerTaskHash,
      this.manufacturingOrderCode,
      this.isSent
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/operation-scheduler-task.ts